module.exports = __webpack_public_path__ + "img/shogi_2021_pack_4_0006.f0ae80d5.png";